exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#container {\n  background-color: white;\n  padding: 24px; }\n\n#hint {\n  line-height: 1.2;\n  margin-bottom: 6px; }\n\n.error {\n  color: red;\n  margin-top: 6px; }\n\n#title {\n  text-transform: uppercase;\n  color: #848484;\n  font-weight: 500;\n  border-bottom: 1px solid #f0f0f0;\n  font-size: .75rem;\n  margin-bottom: .75rem; }\n\n#statement {\n  word-wrap: break-word; }\n", ""]);

// exports
